import React, { createContext, useContext, useMemo } from "react";
import { Patient, User } from "../../../types";

interface PeopleDictionaryContextValue {
    userDictionary: Record<string, User>;
    patientDictionary: Record<string, Patient>;
    isLoading: boolean;
}

interface ProposeMeetingContextProps {
    children: React.ReactNode;
    userDictionary: Record<string, User>;
    patientDictionary: Record<string, Patient>;
    isLoading?: boolean;
}

const ProposeMeetingContext = createContext<PeopleDictionaryContextValue | undefined>(undefined);

export const ProposeMeetingProvider: React.FC<ProposeMeetingContextProps> = ({
    children,
    userDictionary,
    patientDictionary,
    isLoading = false,
}) => {
    const value = useMemo(
        () => ({
            userDictionary,
            patientDictionary,
            isLoading,
        }),
        [userDictionary, patientDictionary, isLoading]
    );

    return <ProposeMeetingContext.Provider value={value}>{children}</ProposeMeetingContext.Provider>;
};

export const useProposeMeeting = () => {
    const ctx = useContext(ProposeMeetingContext);
    if (!ctx) {
        throw new Error("usePeopleDictionaries must be used inside ProposeMeetingContext");
    }
    return ctx;
};